var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-edit"
  }, [_vm.editLink ? _c('div', {
    staticClass: "edit-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.editLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.editLinkText))]), _vm._v(" "), _c('OutboundLink')], 1) : _vm._e(), _vm._v(" "), _vm.$themeConfig.tag !== false && _vm.tags && _vm.tags[0] ? _c('div', {
    staticClass: "tags"
  }, _vm._l(_vm.tags, function (item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": `/tags/?tag=${encodeURIComponent(item)}`,
        "title": "标签"
      }
    }, [_vm._v("#" + _vm._s(item))]);
  }), 1) : _vm._e(), _vm._v(" "), _vm.lastUpdated ? _c('div', {
    staticClass: "last-updated"
  }, [_c('span', {
    staticClass: "prefix"
  }, [_vm._v(_vm._s(_vm.lastUpdatedText) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.lastUpdated))])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };